// Permission configurations for different modules
export const PERMISSION_CONFIGS = {
    signage: {
        groups: [
            { key: "contact", title: "Contact Management", rows: ["Agents", "Brokerage Firms"] },
            {
                key: "inventory",
                title: "Inventory Management",
                rows: [
                    "Standard Inventory",
                    "Office Inventory",
                    "Agent Inventory",
                    "Brands",
                    "Categories",
                    "Attributes",
                    "Rotational Products",
                    "Incoming Agents Products",
                    "Incoming Office Products",
                ],
            },
            { key: "jobs", title: "Jobs and Sales Order Management", rows: ["Orders", "Installations", "Removals", "Active Installations"] },
            {
                key: "business_config",
                title: "Business Configuration",
                rows: ["Groups", "Discounts", "Special Fees", "Dynamic Cost"],
            },
            {
                key: "financial",
                title: "Financial Management",
                rows: ["Payment Methods", "Batch Payments", "Postage Wallet", "Overdue Trigger Configuration", "Invoice Templates"],
            },
            {
                key: "shipping",
                title: "Shipping & Logistics",
                // rows: ["Shipments", "Shipping Presets", "Buy Labels", "Shipping Methods & Cost"],
                rows: ["Shipping Presets", "Buy Labels", "Shipping Methods & Cost"],
            },
            {
                key: "integrations",
                title: "Integrations",
                rows: ["Integrations"],
            },
            {
                key: "insights",
                title: "Insights & Reporting",
                rows: ["Dashboard", "Reports"],
            },
            {
                key: "projects",
                title: "Projects",
                rows: ["Projects"],
            },
            {
                key: "marketplace",
                title: "Marketplace",
                rows: ["Marketplace Profile"],
            },
            {
                key: "settings",
                title: "Settings",
                rows: ["General", "Tax Settings"],
            },
            {
                key: "post_types",
                title: "Post Types",
                rows: ["Post Type"],
            },
            {
                key: "studio",
                title: "Studio",
                rows: ["Studio"],
            },
            {
                key: "brokerage_change_requests",
                title: "Brokerage Change Requests",
                rows: ["Change Requests"],
            },
        ],
        resourceMap: {
            // Contact Management
            "Agents": "agents",
            "Brokerage Firms": "brokerage_firms",

            // Inventory Management
            "Standard Inventory": "standard_inventory",
            "Office Inventory": "office_inventory",
            "Agent Inventory": "agent_inventory",
            "Brands": "brands",
            "Categories": "categories",
            "Attributes": "attributes",
            "Rotational Products": "assets",
            "Incoming Agents Products": "agent_incoming_products",
            "Incoming Office Products": "office_incoming_products",

            // Jobs and Sales Order Management
            "Orders": "orders",
            "Installations": "installation_orders",
            "Removals": "removal_orders",
            "Active Installations": "active_installations",

            // Business Configuration
            "Groups": "customer_groups",
            "Discounts": "discounts",
            "Special Fees": "special_fees",
            "Dynamic Cost": "dynamic_costs",

            // Financial Management
            "Payment Methods": "payment_methods",
            "Batch Payments": "batch_payments",
            "Postage Wallet": "postage_wallet",
            "Overdue Trigger Configuration": "overdue_trigger_configuration",
            "Invoice Templates": "invoice_templates",

            // Shipping & Logistics
            // "Shipments": "shipments",
            "Shipping Presets": "shipping_presets",
            "Buy Labels": "buy_labels",
            "Shipping Methods & Cost": "shipping_methods_cost",

            // Integrations
            "Integrations": "integrations",

            // Insights & Reporting
            "Dashboard": "dash_board",
            "Reports": "reports",

            // Projects
            "Projects": "projects",

            // Marketplace
            "Marketplace Profile": "marketplace_profile",

            // Settings (signage only)
            "General": "general_settings",
            "Tax Settings": "tax_settings",

            // Post Types
            "Post Type": "post_types",

            // Studio (resource `studio`, scope signage — create / view / edit / delete)
            "Studio": "studio",

            // Brokerage Change Requests (view only)
            "Change Requests": "brokerage_change_requests",
        }
    },

    brokerage: {
        groups: [
            { key: "agents", title: "Agents", rows: ["Agents"] },
            {
                key: "inventory",
                title: "Inventory",
                rows: ["Office Inventory", "Agent Inventory", "Brands", "Categories", "Batch Payments", "Dashboard", "Reports"],
            },
            { key: "orders", title: "Orders", rows: ["Orders"] },
            { key: "jobs", title: "Jobs", rows: ["Installations", "Removals","Active Installations"] },
            { key: "suppliers", title: "Suppliers", rows: ["Suppliers"] },
            {
                key: "brokerage_change_requests",
                title: "Vendor Change Requests",
                rows: ["Change Requests"],
            },
        ],
        resourceMap: {
            // Agents
            "Agents": "brokerage_agents",

            // Inventory
            "Office Inventory": "office_inventory",
            "Agent Inventory": "agent_inventory",
            // "Office and Agent Inventory": "office_agent_inventory",
            "Brands": "brands",
            "Categories": "categories",
            "Batch Payments": "batch_payments",
            "Dashboard": "dash_board",
            "Reports": "reports",

            // Orders
            "Orders": "orders",

            // Jobs
            "Installations": "installation_orders",
            "Removals": "removal_orders",
            "Active Installations": "active_installations",

            // Suppliers
            "Suppliers": "suppliers",

            // Vendor Change Requests (view + approve)
            "Change Requests": "brokerage_change_requests",
        }
    }
};

export type PermissionConfig = typeof PERMISSION_CONFIGS.signage;

export type ResourceMap = Record<string, string>;

export type PermissionAction = "create" | "view" | "edit" | "delete" | "approve";

// Resources that support a custom set of actions.
// Resources not listed here support create / view / edit / delete.
export const ALLOWED_ACTIONS: Record<string, Record<string, PermissionAction[]>> = {
  signage: {
    brokerage_change_requests: ["view"],
  },
  brokerage: {
    brokerage_change_requests: ["view", "approve"],
  },
};

// Resources/actions that should be forced (checked + non-editable) per module.
export const FORCED_PERMISSIONS: Record<string, Record<string, PermissionAction[]>> = {
  signage: {
    // active_installations: force create, edit, delete to be checked and non-editable
    active_installations: ["create", "edit", "delete"],
  },
};
